import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home-item-icon10",
  "use": "icon-home-item-icon10-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-home-item-icon10\">\n<path d=\"M2.9,2.9h14.2c0.5,0,0.9,0.4,0.9,0.9v1.8H2V3.8C2,3.3,2.4,2.9,2.9,2.9z M2,7.3H18v8.8c0,0.5-0.4,0.9-0.9,0.9H2.9\n\tc-0.5,0-0.9-0.4-0.9-0.9V7.3z M9.6,12.7v0.9H7.8v0.9h1.8v0.9h0.9v-0.9h1.8v-0.9h-1.8v-0.9h1.8v-0.9h-1.6l1.5-1.5l-0.6-0.6L10,11.1\n\tL8.5,9.7l-0.6,0.6l1.5,1.5H7.8v0.9H9.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home-item-icon10.svg
// module id = eu1J
// module chunks = 97